import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch } from './Store';
import type { RootState } from './rootReducer';

/**
 * Always these, never bare `useDispatch()`/`useSelector()` — an untyped dispatch accepts a
 * thunk the store cannot run, and an untyped selector silently returns `any`.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
